export type Appearance = App.Enums.Appearance;
export type ResolvedTheme = "light" | "dark";
export interface SystemPreferenceChangedEvent {
  readonly type: "SYSTEM_PREFERENCE_CHANGED";
  readonly systemPrefersDark: boolean;
}

export const APPEARANCE_COOKIE_NAME = "appearance" satisfies App.Enums.ClientCookie;
export const SYSTEM_THEME_QUERY = "(prefers-color-scheme: dark)";
export const APPEARANCE_VALUES = {
  dark: "dark",
  light: "light",
  system: "system",
} satisfies Record<Appearance, Appearance>;
const appearanceValues = new Set<string>(Object.values(APPEARANCE_VALUES));

export const isAppearance = (value: string | null): value is Appearance =>
  value !== null && appearanceValues.has(value);

export const resolveTheme = (appearance: Appearance, systemPrefersDark: boolean): ResolvedTheme => {
  if (appearance === "dark") {
    return "dark";
  }

  if (appearance === "light") {
    return "light";
  }

  return systemPrefersDark ? "dark" : "light";
};
